/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {
        title: "Главная страница",
        url: "/",
        icon: "HomeIcon",
        is_bookmarked: false
      },
      {
        title: "Новости",
        url: "/news",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Создать новость",
        url: "/news/new",
        icon: "FileIcon",
        is_bookmarked: false
      },

      {
        title: "Голосования",
        url: "/votings",
        icon: "FileIcon",
        is_bookmarked: false
      },

      {
        title: "Мероприятия",
        url: "/booking/events",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Категории бронирования",
        url: "/booking/categories",
        icon: "FileIcon",
        is_bookmarked: false
      },

      {
        title: "Категории консьерж-сервиса",
        url: "/services/categories",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Создать категорию консьерж-сервиса",
        url: "/services/categories/new",
        icon: "FileIcon",
        is_bookmarked: false
      },

      {
        title: "Вызов охраны",
        url: "/security",
        icon: "FileIcon",
        is_bookmarked: false
      },

      {
        title: "Заявки",
        url: "/requests",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Камеры",
        url: "/cameras",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Жители",
        url: "/residents",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Список адресов",
        url: "/homes",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Сотрудники",
        url: "/employees",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Тарифы комм. платежей",
        url: "/communal-payments/tariffs",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Счета",
        url: "/communal-payments/bills",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Лицевые счета",
        url: "/communal-payments/personal-accounts",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Создать Лицевой счет",
        url: "/communal-payments/personal-accounts/new",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Счетчики эл. энергии",
        url: "/counters/electricity",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Счетчики холодной воды",
        url: "/counters/cold-water",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Товары в Маркете",
        url: "/market/products",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Создать товар в Маркете",
        url: "/market/products/new",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Заказы в Маркете",
        url: "/market/orders",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Меню в Кафе",
        url: "/cafe/dishes",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Создать блюдо в Кафе",
        url: "/cafe/dishes/new",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Заказы в Кафе",
        url: "/cafe/orders",
        icon: "FileIcon",
        is_bookmarked: false
      }
    ]
  }
};
/* eslint-enable */
